import { z } from "zod";

export const ROLE_FILTER_SCHEMA = z
  .string()
  .nullable()
  .transform((value) => {
    if (!value) return [];
    return value
      .split(",")
      .map(Number)
      .filter((num) => !isNaN(num));
  })
  .catch([]);

export type RoleFilter = z.infer<typeof ROLE_FILTER_SCHEMA>;
